import { cn } from '@/lib/cn';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  className?: string;
}

/** 46x26 pill switch: gold when on, line when off. The knob slides 150ms. */
export function Toggle({ checked, onChange, label, className }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      onClick={() => onChange(!checked)}
      className={cn(
        'relative h-[26px] w-[46px] shrink-0 rounded-[13px] border border-line2 p-0 transition-colors duration-150 motion-reduce:transition-none',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accFill',
        checked ? 'bg-accFill' : 'bg-line',
        className
      )}
    >
      <span
        className={cn(
          'absolute top-[3px] h-[18px] w-[18px] rounded-full bg-bg transition-[left] duration-150 motion-reduce:transition-none',
          checked ? 'left-[23px]' : 'left-[3px]'
        )}
      />
    </button>
  );
}
